/**
 * Home page Splide initializers (hero banner + performers).
 *
 * Must be enqueued with a dependency on `splide-js` so WordPress (and
 * LiteSpeed deferred JS) always load Splide before this file.
 *
 * Do not wrap solely in DOMContentLoaded: LiteSpeed converts mid-page
 * inline scripts into deferred data: URIs that can register after the
 * event has already fired, which silently skips initialization.
 */
(function () {
	'use strict';

	/**
	 * Mount the home hero image carousel when the markup and Splide exist.
	 *
	 * @returns {void}
	 */
	const initHomeHeroBanner = () => {
		const root = document.getElementById('home-hero-banner-slider');

		if (!root || typeof Splide === 'undefined') {
			return;
		}

		if (root.classList.contains('is-initialized')) {
			return;
		}

		new Splide(root, {
			type: 'fade',
			rewind: true,
			perPage: 1,
			perMove: 1,
			pagination: true,
			arrows: true,
			autoplay: true,
			interval: 5000,
			pauseOnHover: true,
			pauseOnFocus: true,
			speed: 600,
			lazyLoad: false,
		}).mount();
	};

	/**
	 * Mount the achiever / performers carousel on the home page.
	 *
	 * @returns {void}
	 */
	const initPerformersSlider = () => {
		const root = document.getElementById('performers-slider');

		if (!root || typeof Splide === 'undefined') {
			return;
		}

		if (root.classList.contains('is-initialized')) {
			return;
		}

		new Splide(root, {
			type: 'slide',
			perPage: 5,
			perMove: 1,
			gap: '30px',
			pagination: false,
			arrows: true,
			autoplay: true,
			interval: 3000,
			pauseOnHover: true,
			classes: {
				arrows: 'splide__arrows performers-slider-arrows',
				arrow: 'splide__arrow performers-slider-arrow',
				prev: 'splide__arrow--prev performers-slider-arrow--prev',
				next: 'splide__arrow--next performers-slider-arrow--next',
			},
			breakpoints: {
				1300: {
					perPage: 4,
					gap: '20px',
				},
				1023: {
					perPage: 3,
					gap: '20px',
				},
				767: {
					perPage: 2,
					gap: '20px',
				},
				576: {
					perPage: 1,
					gap: '10px',
				},
			},
		}).mount();
	};

	/**
	 * Boot all home sliders once the DOM nodes are available.
	 *
	 * @returns {void}
	 */
	const bootHomeSliders = () => {
		initHomeHeroBanner();
		initPerformersSlider();
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bootHomeSliders);
	} else {
		bootHomeSliders();
	}
})();
